import React from 'react'

import PropTypes from 'prop-types'

const Feedback = (props) => {
  // disable Add Feedback form because causing bug (ask @David Tobing)
  const showAddFeedback = false

  return (
    <div className="table-scrollable table-scrollable-borderless">
      {props.feedbacks.length > 0
        ? (
          <table className="table table-hover table-light">
            <tbody>
              <tr>
                <th>Feedback</th>
                <th> Profile Name </th>
                <th> User Name </th>

              </tr>
              {props.feedbacks.map(feedback => (
                <tr key={feedback.id}>
                  <td dangerouslySetInnerHTML={{ __html: `${feedback.say}` }} />
                  <td> {feedback.profile.name} </td>
                  <td> {feedback.user.firstName} {feedback.user.lastName} </td>
                </tr>
              ))
              }
            </tbody>
          </table>
          )
        : ''
      }

      { showAddFeedback && (
        <div>
          <h4 className="sbold blog-comments-title">Add Feedback</h4>
          <form
            className="col-md-4 no-space"
            onSubmit={props.handleSubmitFeedback}
          >
            <div
              className="form-group col-md-12"
              style={{ padding: '0' }}
            >
              <textarea
                style={{ resize: 'none' }}
                rows="5"
                name="message"
                placeholder="how should the creator improve this pitch"
                className="form-control c-square"
                onChange={props.handleChangeFeedback}
              />
            </div>
            <div
              className="form-group col-md-12 no-padding"
              style={{ padding: '0' }}
            >
              <button
                type="submit"
                className="btn blue uppercase btn-md sbold btn-block"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      )}

    </div>
  )
}

Feedback.defaultProps = {
  feedbacks: [{}],
  handleChangeFeedback: () => {},
  handleSubmitFeedback: () => {},
}

Feedback.propTypes = {
  feedbacks: PropTypes.arrayOf(PropTypes.object),
  handleChangeFeedback: PropTypes.func,
  handleSubmitFeedback: PropTypes.func,
}


export default Feedback
